import organization from "./organizationReducer";
import organizationUsers from "./organizationUsersReducer";
import reportScheduler from "./reportSchedulerReducer";

export default {
	organization,
	organizationUsers,
	reportScheduler
};
